import 'css-chunksrc/client/pages/milestonePage/details/styles.scss';export default {
  "details": "_details_15dr1_1",
  "late": "_late_15dr1_5",
  "name": "_name_15dr1_5",
  "completed": "_completed_15dr1_9",
  "header": "_header_15dr1_13",
  "title": "_title_15dr1_19",
  "icon": "_icon_15dr1_23",
  "input": "_input_15dr1_38",
  "description": "_description_15dr1_48",
  "label": "_label_15dr1_52",
  "paragraph": "_paragraph_15dr1_58",
  "advancement": "_advancement_15dr1_68",
  "percentage": "_percentage_15dr1_75",
  "progressBar": "_progressBar_15dr1_84",
  "advancementLabel": "_advancementLabel_15dr1_89",
  "descriptionMaxChars": "_descriptionMaxChars_15dr1_96",
  "loader": "_loader_15dr1_101",
  "loaderMain": "_loaderMain_15dr1_109"
};